<script setup>
/* global axios */
// Aba "Assinatura" das configurações da caixa (issue #21): o GESTOR liga aqui a
// assinatura das mensagens do WhatsApp oficial, em vez de deixar a cargo de cada
// agente no perfil dele. Ligado, toda resposta de atendente sai com o nome de
// quem enviou em negrito. Templates (HSM) nunca são assinados — texto extra
// quebraria a validação da Meta.
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const route = useRoute();
const accountId = route.params.accountId;
const base = `/api/v1/accounts/${accountId}/inboxes/${props.inbox.id}/signature`;

const enabled = ref(false);
const senderName = ref('');
const saving = ref(false);

const load = async () => {
  try {
    const { data } = await axios.get(base);
    enabled.value = !!data.enabled;
    senderName.value = data.sender_name || '';
  } catch (e) {
    enabled.value = false;
  }
};

const toggle = async value => {
  saving.value = true;
  try {
    const { data } = await axios.patch(base, { enabled: value });
    enabled.value = !!data.enabled;
    useAlert(t('INBOX_MGMT.INBOX_SIGNATURE.SAVED'));
  } catch (e) {
    useAlert(e?.response?.data?.error || t('INBOX_MGMT.INBOX_SIGNATURE.ERROR'));
  } finally {
    saving.value = false;
  }
};

onMounted(load);
</script>

<template>
  <div class="p-6 mx-6 max-w-3xl">
    <h4 class="text-base font-medium text-n-slate-12">
      {{ t('INBOX_MGMT.INBOX_SIGNATURE.TITLE') }}
    </h4>
    <p class="mt-1 mb-4 text-sm text-n-slate-11">
      {{ t('INBOX_MGMT.INBOX_SIGNATURE.DESC') }}
    </p>

    <div
      class="flex items-center gap-4 p-4 border rounded-xl border-n-weak bg-n-solid-1"
    >
      <div class="flex-1 min-w-0">
        <div class="font-medium text-n-slate-12">
          {{ t('INBOX_MGMT.INBOX_SIGNATURE.TOGGLE_LABEL') }}
        </div>
        <p class="mt-1 text-sm text-n-slate-10">
          {{ t('INBOX_MGMT.INBOX_SIGNATURE.TOGGLE_DESC') }}
        </p>
      </div>
      <Switch
        :model-value="enabled"
        :disabled="saving"
        @update:model-value="toggle"
      />
    </div>

    <!-- Prévia com o nome de quem está olhando a tela, só para ilustrar o formato -->
    <div
      v-if="enabled && senderName"
      class="p-4 mt-4 border rounded-xl border-n-weak bg-n-alpha-1"
    >
      <div class="mb-1 text-xs uppercase text-n-slate-10">
        {{ t('INBOX_MGMT.INBOX_SIGNATURE.PREVIEW') }}
      </div>
      <p class="text-sm font-bold text-n-slate-12">{{ senderName }}</p>
      <p class="text-sm text-n-slate-12">
        {{ t('INBOX_MGMT.INBOX_SIGNATURE.PREVIEW_MESSAGE') }}
      </p>
    </div>

    <p class="mt-4 text-xs text-n-amber-11">
      {{ t('INBOX_MGMT.INBOX_SIGNATURE.TEMPLATE_NOTE') }}
    </p>
  </div>
</template>
